/* eslint-disable react-hooks/rules-of-hooks */
import { useCallback } from 'react';

const eligibilityChecks = {
    'ORGANIZATION_SDGS_PIECHART': (dto) => {
        return true;
    },
    'ORGANIZATION_AUE_PIECHART': (dto) => {
        return true;
    },
    'ORGANIZATION_LOGO_NAME': (dto) => {
        return true;
    },
    'ORGANIZATION_AREA_INDICATORS': (dto) => {
        return true;
    }
};

export function use_ORGANIZATION_eligibilityHelper() {
    // Define the helpers inside the hook and memoize them
    const isTemplateEligible = useCallback((template, dto) => {
        const check = eligibilityChecks[template.acronym];
        return check ? check(dto) : false;
    }, []);

    const getApplicableTemplates = useCallback((templates, dto) => {
        return templates.filter(template => isTemplateEligible(template, dto));
    }, [isTemplateEligible]);

    return {
        isTemplateEligible,
        getApplicableTemplates,
    };
}    